import consultRequestCreator from '../../consultRequestCreator';
import urlConstants from '../../../constants/urlConstants';

export function fetchUsersInit() {
  return consultRequestCreator
    .get(urlConstants.USERS_INIT)
    .then(response => response.data);
}
